import { create } from 'zustand';
import { CoreWebexAuthState } from '../workplace/services/CoreWebexService';

interface CoreWebexStore extends CoreWebexAuthState {
  // Actions
  setAuthState: (updates: Partial<CoreWebexAuthState>) => void;
  resetAuthState: () => void;
}

const initialState: CoreWebexAuthState = {
  isAuthenticated: false,
  isValidating: false,
  isInitializingWebhook: false,
  token: null,
  session: null,
  error: null,
};

export const useCoreWebexStore = create<CoreWebexStore>()((set) => ({
  ...initialState,

  // Actions
  setAuthState: (updates: Partial<CoreWebexAuthState>) => {
    set((state) => ({
      ...state,
      ...updates,
    }));
  },

  resetAuthState: () => {
    set(initialState);
  },
}));

// Simple selectors for easy access
export const selectWebexToken = (state: CoreWebexStore) => state.token;
export const selectWebexSession = (state: CoreWebexStore) => state.session;
export const selectIsWebexAuthenticated = (state: CoreWebexStore) => state.isAuthenticated;
export const selectIsWebexValidating = (state: CoreWebexStore) => state.isValidating;
